export default __webpack_public_path__ + "static/media/tollfree_duration.dbaec765.svg";